/**
 * @file 订阅
 * @author yuanyaojia<yuanyaojia@baijia.com>
 * @date 2021-4-21
 */

import http from './http';
import constant from './constant';

/**
   * 取消订阅
   * url: /customize/cancel.json
   * 方法：POST
   */

export const unsubscribe = params => http.post(constant.SUBSCRIBE.CANCEL, params);

/**
   * 保存订阅
   * url: /customize/save.json
   * 方法：POST
   */

export const saveSubscribe = params => http.post(constant.SUBSCRIBE.SUBSCRIBE, params);
